<template lang="pug">
  header
    accessibility-nav
    .container.hidden-xs.hidden-sm
      .site-topo
        router-link(:to="{ name: 'Index' }")
          h1(style="display:inline-block;")
            img(src="static/logo_desktop.png", title="Logomarca da PROAD")
        barra-busca
</template>

<style lang="scss">
  .site-topo {
    position: relative;
    padding: 40px 0;
    text-align: center;
    > a { display: inline-block }
    .form-group { margin: 0; }
    .barra-busca {
      position: absolute;
      right: 0;
    }
  }
</style>

<script>
  import AccessibilityNav from 'COMPONENTS/AccessibilityNav'
  import BarraBusca from 'COMPONENTS/BarraBusca'
  export default {
    name: 'site-header',
    components: { AccessibilityNav, BarraBusca }
  }
</script>



// WEBPACK FOOTER //
// PageHeader.vue?73072c36